module.exports = __webpack_public_path__ + "img/standard_disabled_mobile.61967ba7.png";